let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5prMw")).then(() => parcelRequire('eiWvW'));